var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._t("list-header"),_vm._t("data-list"),_vm._t("credit_card_empty"),_vm._t("link_account_empty")],2)}
var staticRenderFns = []

export { render, staticRenderFns }